// extracted by mini-css-extract-plugin
module.exports = {"overlay":"styles_overlay__a5IiS","products-count":"styles_products-count__tnD81"};